
import foodIcon from "./assets/food.svg";
import movieIcon from "./assets/movie.svg";
import travelIcon from "./assets/travel.svg";

export const dummyData = [
    {
      name: "Samosa",
      date: "2024-03-18",
      category: "food",
      price: 50,
      id: 1711460238574
    },
    {
      name: "Auto",
      date: "2024-03-18",
      category: "travel",
      price: 150,
      id: 1711460238579
    },
    {
      name: "Movie",
      date: "2024-03-18",
      category: "entertainment",
      price: 300,
      id: 1711460238577
    },
    {
      name: "Bus",
      date: "2024-03-18",
      category: "travel",
      price: 100,
      id: 17114602385755
    },
    {
      name: "Burger",
      date: "2024-03-18",
      category: "food",
      price: 100,
      id: 17114602385755
    },
    {
      name: "IPL Match",
      date: "2024-03-18",
      category: "entertainment",
      price: 500,
      id: 171146023857578
    },
  ]

